import { useState, useCallback, useEffect, useMemo } from 'react';
import { isDesktop } from 'react-device-detect';
import { useLandscapeDetection } from '@hooks/orientation';
import { useChatState } from '@core/chat';
import { useMytaverseEvent } from '@core/dashboard/providers';

export const useShowOrientationOverlay = () => {
  const isLandscape = useLandscapeDetection();
  const { showAvaturnModal } = useMytaverseEvent();
  const [isOverlayVisible, setIsOverlayVisible] = useState(
    !isDesktop && !isLandscape,
  );
  const { setOpen: setOpenChat } = useChatState();

  useEffect(() => {
    if (isDesktop) {
      return;
    }

    if (!isLandscape) {
      setOpenChat(false);
      setIsOverlayVisible(true);
    } else {
      setIsOverlayVisible(false);
    }
  }, [isLandscape]);

  const showOverlay = useMemo(
    () => !isDesktop && isOverlayVisible && !showAvaturnModal,
    [isOverlayVisible, showAvaturnModal],
  );

  const handleHideOverlay = useCallback(() => {
    setIsOverlayVisible(false);
  }, []);

  return useMemo(
    () => ({ isLandscape, showOverlay, handleHideOverlay }),
    [isLandscape, showOverlay],
  );
};
